export default __webpack_public_path__ + "static/media/kitchen4-afterA-1920w.43ee936b.avif";